import {
  Component,
  Input,
  AfterViewInit,
  OnDestroy,
  Output,
  EventEmitter,
  AfterViewChecked
} from '@angular/core';
// import 'tinymce';
// import 'tinymce/themes/silver';
// import 'tinymce/plugins/autoresize';
// import 'tinymce/plugins/fullscreen';
// import 'tinymce/plugins/paste';
// import 'tinymce/plugins/code';
// import 'tinymce/plugins/wordcount';
// import 'tinymce/plugins/image';
declare var tinymce: any;
@Component({
  selector: 'app-tiny-editor',
  template: `<div id='{{id}}' class='mce-editor' [innerHTML]="content"></div>`
})
export class TinyEditorComponent implements  OnDestroy {
  private editor: any;
  private _disabled: boolean;
  private _isActive: boolean;
  @Input() id: string;
  @Input()
  set disabled(status: boolean) {
    this._disabled = status;
    if (this.editor) {
      this.editor.getBody().setAttribute('contenteditable', !status);
    }
  }
  get disabled(): boolean {
    return this._disabled;
  }
  @Input()
  get isActive(): boolean { return this._isActive; }
  set isActive(val: boolean) {
    this._isActive = val;
    if (this._isActive) {
      tinymce.remove();
      tinymce.init({
        branding: false,
        debounce: false,
        menubar: false,
        selector: `#${this.id}`,
        language: 'es_MX',
        language_url: '/assets/tinymce/languages/es_MX.js',
        skin_url: '/assets/tinymce/skins/ui/oxide',
        content_css: '/assets/tinymce/skins/content/default/content.css',
        plugins: ['autoresize', 'image', 'paste', 'wordcount', 'code', 'stylebuttons', 'fullscreen'],
        toolbar: 'bold italic | style-h2 | image | code | fullscreen',
        autoresize_bottom_margin: 0,
        autoresize_max_height: 1000,
        elementpath: false,
        paste_as_text: true,
        setup: editor => {
          this.editor = editor;
          editor.on('init', (e) => {
            e.target.getBody().setAttribute('contenteditable', !this.disabled);
          });
          editor.on('keyup change', () => {
            const content = editor.getContent();
            this.editorContentChange.emit(content);
          });
        }
      });
    }
  }
  @Input() content: String;
  @Output() editorContentChange = new EventEmitter<string>();

  constructor() { }

  ngOnDestroy() {
    tinymce.remove();
  }
}
